import { filterType, filterData } from "../../../../../helpers/filterHelper";
import { store } from "../../../../../config/store";
import { showToastError, showMessageApi, showToastSuccess } from "../../../../Main/actions";
import { getEmpresas, getEmpresa, putEmpresa, postEmpresa, getDataEmpresa, createEmpresa, updateEmpresa, getDocumentAgreementApi } from "../../../../../services/mantenedoresSelApi";
import trace from "../../../../../helpers/trace";

export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDOR_EMPRESA",
  isLoading,
});

export const setBase64 = (value) => ({
  type: "SET_BASE_64_FILE",
  value,
});

export const doGetFiltrosEmpresas = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const filtros = [
      {
        column: "SelService",
        name: "Servicio SEL",
        type: "bool",
        values: [
          { value: true, text: "Activo" },
          { value: false, text: "Inactivo" },
        ],
      },
      {
        column: "HasAgreements",
        name: "Convenios",
        type: "bool",
        values: [
          { value: true, text: "Con Convenio" },
          { value: false, text: "Sin Convenio" },
        ],
      }
    ];
    dispatch(setFiltrosEmpresas(filtros));
  } catch (e) {
    trace.error("doGetFiltrosCupos", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const setListaEmpresas = (data) => ({
  type: "SET_LISTA_EMPRESA",
  data,
});

export const setListaEmpresasFiltradas = (lista) => ({
  type: "SET_LISTA_EMPRESAS_FILTRADAS",
  lista,
});

export const setFiltrosEmpresas = (filtros) => ({
  type: "SET_FILTROS_EMPRESAS",
  filtros,
});

export const openCloseModalEliminarEmpresa = (isOpen, empresa) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_EMPRESA",
  isOpen,
  empresa,
});

export const openCloseModalDesactivarEmpresa = (isOpen, empresa) => ({
  type: "OPEN_CLOSE_MODAL_DESACTIVAR_EMPRESA",
  isOpen,
  empresa,
});

export const setEmpresa = (data) => ({
  type: "SET_EMPRESA",
  data,
});

export const openCloseModalEditarEmpresa = (isOpen, empresa, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_EMPRESA",
  isOpen,
  empresa,
  isNew,
});

export const doGetEmpresas = (filtros, reload = false) => async (dispatch) => {
  dispatch(loading(true));
  try {

    let data = [];
    
    const request = await getEmpresas();
    if (request.status === 200) {
      data = await request.json();
      dispatch(setListaEmpresas(data));
    }
    
    // if (filtros) {
    //   const newData = filterData(data, filtros);
    //   dispatch(setListaEmpresasFiltradas(newData));
    // }

  } catch (e) {
    trace.error("doGetEmpresas", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetEmpresa = (rut) => async (dispatch) => {
  dispatch(loading(true));
  try {
           
    let message;
    let data = {};

    if (rut) {
      const request = await getEmpresa(rut);
      if (request.status === 200) {
        data = await request.json();
        dispatch(setEmpresa(data));
      }
      if (request.status === 204) {
        const newEmpresa = {
          isNoContent: true,
          CompanyRut: rut,
          CompanyName: null,
          SelService: false,
          SelSegment: 1,
          NoNameLimit: 0,
          NoNameTime: 0,
          Approvers: [],
          ApproversQuota: 0,
          Agreements: [],
          AgreementsQuota: 0
        }
        dispatch(setEmpresa(newEmpresa));
        message = `No se ha encontrado ninguna empresa con el rut ingresado`;
      }
      dispatch(showMessageApi(message, request));
    }
    
  } catch (e) {
    trace.error("doGetEmpresa", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doPostEmpresa = (empresa) => async (dispatch) => {
  dispatch(loading(true));
  try {
           
    let message;
    
    var data = empresa;

    if (data) {
      const request = await postEmpresa(data);
      if (request.status === 200) {
        //data = await request.json();
        dispatch(doGetEmpresas((null, true)));
      }
      dispatch(showToastSuccess("Empresa agregada con éxito"))
    }
    
  } catch (e) {
    var test = e;
    trace.error("doPostEmpresa", e);
    //dispatch(showToastError());
  }
  //dispatch(loading(false));
};

export const doPutEmpresa = (empresa) => async (dispatch) => {
  dispatch(loading(true));
  try {
           
    let message;
    
    var data = empresa;

    if (data) {
      const request = await putEmpresa(data);
      if (request.status === 200) {
        //data = await request.json();
        dispatch(doGetEmpresas((null, true)));
      }
      dispatch(showToastSuccess("Empresa modificada con éxito"))
    }
    
  } catch (e) {
    var test = e;
    trace.error("doPutEmpresa", e);
    //dispatch(showToastError());
  }
  //dispatch(loading(false));
};

export const doGetDataEmpresa = (rut) => async (dispatch) => {
  dispatch(loading(true));
  try {
           
    let message;
    let data = {};

    if (rut) {
      const request = await getDataEmpresa(rut);
      if (request.status === 200) {
        data = await request.json();
        if (data.SearchCompany === true && data.SearchCompanySel === true) {
          dispatch(doGetEmpresa(rut));
        }else 
        if (data.SearchCompany === true && data.SearchCompanySel === false) {
          const newEmpresa = {
            isNoContent: true,
            CompanyRut: rut,
            CompanyName: data.CompanyName,
            SelService: false,
            SelSegment: 1,
            NoNameLimit: 0,
            NoNameTime: 0,
            Approvers: [],
            ApproversQuota: 0,
            Agreements: [],
            AgreementsQuota: 0
          }
          dispatch(setEmpresa(newEmpresa));
        }else 
        if(data.SearchCompany === false && data.SearchCompanySel === false){
          message = `No se ha encontrado ninguna empresa con el rut ingresado`;
          dispatch(showMessageApi(message, request));
        }
      }
    }
  } catch (e) {
    trace.error("doGetEmpresa", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const getDocumentAgreement = (rut, id) => async (dispatch) => {
  dispatch(loading(true));
  try {    
    const request = await getDocumentAgreementApi(rut, id);
    if (request.status === 200) {
      dispatch(showToastSuccess("La descarga se ha iniciado"))
    }else{
      let message = `No se ha encontrado el documento de convenios`;
      dispatch(showMessageApi(message, request));
    }
    dispatch(showToastSuccess("Empresa modificada con éxito"))      
  } catch (e) {
    trace.error("doPutEmpresa", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
